module.exports = __webpack_public_path__ + "img/down-toggle.1debeae0.svg";